const STORAGE_PREFIX = 'uidMap';

const safeParse = (raw) => {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const getProjectSlugFromPathname = (pathname) => {
  const parts = String(pathname || '')
    .split('/')
    .filter(Boolean);
  if (parts[0] === 'p' && parts[1]) {
    return parts[1];
  }
  return 'default';
};

export const getStationTypeValue = (station) =>
  station?.stationType ||
  station?.station_type ||
  station?.Station_type ||
  station?.type ||
  null;

const getUidMapKey = (slug) => `${STORAGE_PREFIX}:${slug || 'default'}`;

export const getStationUidKey = (stationNum, stationType) => {
  const num = stationNum ?? '';
  const type = stationType ?? '';
  return type ? `${num}-${type}` : String(num);
};

const readUidMap = (slug) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return {};
  return safeParse(window.sessionStorage.getItem(getUidMapKey(slug)));
};

const writeUidMap = (slug, map) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  window.sessionStorage.setItem(getUidMapKey(slug), JSON.stringify(map));
};

export const getStationUuidFromSession = (slug, stationNum, stationType) => {
  const map = readUidMap(slug);
  const key = getStationUidKey(stationNum, stationType);
  return map[key] || null;
};

export const setStationUuidInSession = (slug, stationNum, stationType, uuid) => {
  if (!uuid) return;
  const map = readUidMap(slug);
  const key = getStationUidKey(stationNum, stationType);
  map[key] = uuid;
  writeUidMap(slug, map);
};

export const removeStationUuidFromSession = (slug, stationNum, stationType) => {
  const map = readUidMap(slug);
  const key = getStationUidKey(stationNum, stationType);
  if (key in map) {
    delete map[key];
    writeUidMap(slug, map);
  }
};

